<h5 class="p-16 m-0 bottomBorderStyle">Move</h5>

<div class="box">

  <div class="selectedFilesContainer pos-relative w-p-100 m-0">
    <div class="form-label m-b-m">SELECTED ITEM(S)</div>

    <mat-chip-listbox #chipList aria-label="packagefolder selection">

      @for (package of limitedpackagefolder; track package; let packageIndex = $index) {
        <mat-chip-option
          removable
          (removed)="remove(package)"
          [attr.id]="buildControlId('chip-option', package?.Id || packageIndex)"
          >
          <span
            class="text-overflow-ellipsis chipclass selectedFileOptionFont"
            matTooltipClass="tooltip-style"
            matTooltipPosition="above"
            appMatTooltip="{{ package?.LeafName }}"
            [attr.id]="buildControlId('chip-lbl-selected-item', package?.Id || packageIndex)"
            >
            {{ package?.LeafName }}
          </span>
          <button matChipRemove [attr.id]="buildControlId('btn-remove-chip', package?.Id || packageIndex)">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-option>
      }

      @if (stringlength(packagefolder)) {
        <span
          (click)="overlaydisplay(packagefolder, $event)"
          class="color-link additionalpackageFolder"
          [attr.id]="buildControlId('btn-expand-selection')"
          >
          +{{ packagefolder.length - 6 }} more
        </span>
      }

    </mat-chip-listbox>

    @if (chipList.errorState) {
      <mat-error>
        Please select Item(s) to move
      </mat-error>
    }
  </div>

  <mat-label class="browseFile_NameLabel">Destination</mat-label>

  <form>
    <mat-form-field class="browse_Box">
      <input
        matInput
        [formControl]="destinationPath"
        placeholder=""
        readonly
        required
        matTooltipClass="tooltip-style"
        matTooltipPosition="above"
        appMatTooltip="{{ form.get('destinationPath').value }}"
        [attr.id]="buildControlId('fld-destination-path')"
        />

        <span
          class="text-overflow-ellipsis"
          matTooltipClass="tooltip-style"
          matTooltipPosition="above"
          appMatTooltip="{{ destinationPath }}"
          [attr.id]="buildControlId('lbl-destination-path-tooltip')"
        ></span>

        <span
          class="commonBrowsebtn"
          (click)="openDestinationPopup()"
          [attr.id]="buildControlId('btn-browse-destination')"
          >
          Browse
        </span>
        @if (destinationPath.hasError('required')) {
          <mat-error
            >
            Destination path is mandatory.
          </mat-error>
        }
      </mat-form-field>
    </form>

    <button
      mat-raised-button
      color="primary"
      type="submit"
      class="button_content primary-hover w-p-100"
      (click)="moveItemOnSubmit()"
      [attr.id]="buildControlId('btn-move-submit')"
      >
      Move
    </button>

    <button
      mat-button
      class="mat-button button_content w-p-100"
      color="primary"
      (click)="cancel()"
      [attr.id]="buildControlId('btn-cancel-transfer')"
      >
      Cancel
    </button>

  </div>
